"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// use : $mdButtonInkRipple.attach(scope, element);

ngModule.factory('$mdButtonInkRipple', function MdButtonInkRipple($mdInkRipple) {
  return {
    attach: function attachRipple(scope, element, options) {
      options = angular.extend(optionsForElement(element), options);
      return $mdInkRipple.attach(scope, element, options);
    }
  };
  function optionsForElement(element) {
    if (element.hasClass('md-icon-button')) {
      return {
        isMenuItem: element.hasClass('md-menu-item'),
        fitRipple: true,
        center: true
      };
    } else {
      return {
        isMenuItem: element.hasClass('md-menu-item'),
        dimBackground: true
      };
    }
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/ripple/button-ripple.js
// module id = 2988
// module chunks = 13